<template>
    <article class="page-cabinet-dashboard-highlights">
<!--        <div class="page-cabinet-dashboard-highlights__switchers">
            <div class="page-cabinet-dashboard-highlights__switchers-item"
                v-for="(switcher, index) in modes"
                v-bind:key="index"
                v-bind:class="{ _active: switcher.isActive }"
                v-on:click="setMode(index)"
                v-text="switcher.title"
            />
        </div>-->
        <div class="page-cabinet-dashboard-highlights__blocks">
            <template v-if="!isSmallScreen || (isSmallScreen && page === 1)">
                <div class="page-cabinet-dashboard-highlights__blocks-item">
                    <page-cabinet-dashboard-highlights-card
                        v-bind="investments"
                    />
                </div>
                <div class="page-cabinet-dashboard-highlights__blocks-item">
                    <page-cabinet-dashboard-highlights-card
                        v-bind="estimatedValue"
                    />
                </div>
                <div class="page-cabinet-dashboard-highlights__blocks-item">
                    <page-cabinet-dashboard-highlights-card
                        v-bind="income"
                    />
                </div>
            </template>

            <template v-if="!isSmallScreen || (isSmallScreen && page === 2)">
                <div class="page-cabinet-dashboard-highlights__blocks-item">
                    <page-cabinet-dashboard-highlights-card
                        v-bind="growth"
                    />
                </div>
                <div class="page-cabinet-dashboard-highlights__blocks-item">
                    <page-cabinet-dashboard-highlights-card
                        v-bind="dividends"
                    />
                </div>
                <div class="page-cabinet-dashboard-highlights__blocks-item">
                    <page-cabinet-dashboard-highlights-card
                        v-bind="profit"
                    />
                </div>
            </template>

            <div class="page-cabinet-dashboard-highlights__blocks-item _big">
                <page-cabinet-dashboard-highlights-card
                    v-bind="irr"
                    v-bind:is-accented="true"
                />
            </div>
        </div>

        <div class="page-cabinet-dashboard-highlights__back-forward" v-if="isSmallScreen">
            <ui-button
                v-bind:icon-left="'arrow-left'"
                v-on:click="page = 1"
                theme="secondary-1"
                :isWidthFree="true"
                v-if="page === 2"
            >
                Назад
            </ui-button>
            <ui-button
                v-bind:icon-right="'arrow-right'"
                v-on:click="page = 2"
                theme="secondary-1"
                :isWidthFree="true"
                v-if="page === 1"
            >
                Вперед
            </ui-button>
        </div>
    </article>
</template>

<script>
import { mapState } from 'vuex';
import moment from 'moment';

export default {
    name: 'page-cabinet-dashboard-highlights',
    data: () => {
        const dateFormat = 'YYYY-MM-DD';
        return {
            page: 1,
            screenWidth: window.innerWidth,
            modes: [
                {
                    title: 'Квартал',
                    isActive: false,
                    params: {
                        date_from: moment().subtract(1, 'quarters').format(dateFormat),
                        date_to: moment().format(dateFormat),
                    },
                },
                {
                    title: 'Полгода',
                    isActive: false,
                    params: {
                        date_from: moment().subtract(6, 'months').format(dateFormat),
                        date_to: moment().format(dateFormat),
                    },
                },
                {
                    title: 'Год',
                    isActive: false,
                    params: {
                        date_from: moment().subtract(1, 'years').format(dateFormat),
                        date_to: moment().format(dateFormat),
                    },
                },
                {
                    title: 'Все время',
                    isActive: true,
                    params: {
                    },
                },
            ],
            investments: {
                title: 'Инвестиции',
                value: 0,
                units: '₽',
                description: 'Сумма вложенных денежных средств (и на первичном, и на вторичном рынке) за вычетом стоимости акций, проданных на вторичном рынке.',
            },
            income: {
                title: 'Общий доход',
                value: 0,
                units: '₽',
                delta: 0,
                description: 'Ваша общая прибыль. Складывается из роста стоимости акций, полученных дивидендов и прибыли/убытка от проданных акций за всё время инвестиций.',
            },
            estimatedValue: {
                title: 'Текущая стоимость портфеля',
                value: 0,
                units: '₽',
                delta: 0,
                description: 'Стоимость Ваших инвестиций на текущий момент. Рассчитывается как количество акций в Вашем портфеле, умноженное на рекомендованную цену акций.',
            },
            dividends: {
                title: 'Дивиденды',
                value: 0,
                units: '₽',
                description: 'Сумма всех выплаченных дивидендов за всё время инвестиций.',
            },
            irr: {
                title: 'Доходность (IRR)',
                value: '0',
                units: '%',
                description: 'Общая среднегодовая доходность, включающая в себя рост стоимости, прибыль/убыток от проданных акций и дивиденды.',
            },
            growth: {
                title: 'Рост стоимости',
                value: 0,
                units: '₽',
                description: 'Отражает общую прибыль от роста стоимости за все время инвестиций. Рассчитывается как разница между текущей стоимостью акций (по рекомендованной цене) и стоимостью их покупки.',
            },
            profit: {
                title: 'Прибыль/убыток от продажи акций',
                value: 0,
                units: '₽',
                delta: 0,
                description: 'Разница между стоимостью покупки и продажи акций.',
            },
        };
    },
    computed: {
        ...mapState('dashboard', [
            'getHighlightsResult',
            'getHighlightsError',
            'getHighlightsIsLoading',
        ]),
        activeMode() {
            return this.modes.find(x => x.isActive);
        },
        isSmallScreen() {
            return this.screenWidth < 1023;
        },
    },
    methods: {
        setMode(index) {
            const modes = this.modes;
            const active = modes.find(mode => mode.isActive);
            if (active) {
                active.isActive = false;
            }
            modes[index].isActive = true;
            this.modes = modes;
        },
        checkScreenWidth() {
            this.screenWidth = window.innerWidth;
        },
    },
    watch: {
        getHighlightsResult(newVal) {
            this.$set(this.investments, 'value', newVal.investments.toFixed(0));

            this.$set(this.income, 'value', newVal.income[1].toFixed(0));
            this.$set(this.income, 'delta', newVal.income[3]);

            this.$set(this.dividends, 'value', newVal.dividends[1].toFixed(0));
            this.$set(this.dividends, 'delta', newVal.dividends[3]);

            this.$set(this.estimatedValue, 'value', newVal.portfolio[1].toFixed(0));
            this.$set(this.estimatedValue, 'delta', newVal.portfolio[3]);

            this.$set(this.irr, 'value', (newVal.irr * 100).toFixed(1));

            this.$set(this.growth, 'value', newVal.growth[1].toFixed(0));
            this.$set(this.growth, 'delta', newVal.growth[3]);

            this.$set(this.profit, 'value', newVal.profit[1].toFixed(0));
            this.$set(this.profit, 'delta', newVal.profit[3]);
        },
        activeMode() {
            this.$store.dispatch('dashboard/getHighlights', this.activeMode?.params || {});
        },
    },
    mounted() {
        window.addEventListener('resize', this.checkScreenWidth);
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.checkScreenWidth);
    },
};
</script>

<style scoped lang="less">
@import '~theme';

.page-cabinet-dashboard-highlights {
    padding: 10px 0 24px;
    &__switchers {
        .typography-caption();

        display: flex;
        align-items: baseline;
        justify-content: flex-end;
        width: ~'calc(100% + 24px)';
        margin: 0 -12px;
        &-item {
            padding: 10px 12px;

            color: @color-gray-main;

            cursor: pointer;

            transition: color @duration-fast ease-in-out;
            &._active {
                color: @color-gray-darker;
            }
        }
    }
    &__blocks {
        display: grid;
        grid-template-columns: 1fr 1fr 1fr 1fr;
        grid-template-rows: 1fr 1fr;
        gap: 18px 18px;
        grid-template-areas:
            ". . . big"
            ". . . big";
        &-item {
            &._big {
                grid-area: big;
            }
        }
    }
    &__back-forward {
        display: flex;
        flex-direction: column;
        align-items: center;
        margin-top: 16px;
    }
    @media @media-lg-down {
        &__blocks {
            grid-template-columns: 1fr 1fr 1fr;
            grid-template-rows: auto 1fr 1fr;
            gap: 18px 18px;
            grid-template-areas:
            "big big big"
            ". . ."
            ". . .";
        }
    }
    @media @media-md-down {
        &__switchers {
            justify-content: flex-start;
        }
        &__blocks {
            grid-template-columns: 1fr;
            grid-auto-rows: auto;
            gap: 8px;
            grid-template-areas:
                "big";
        }
    }
}
</style>
